import * as React from "react";
import { observer } from "mobx-react-lite";
import { mk8sMobx } from "../../../../mst/kinds/mk8s/mk8s";
import { Mk8sDraftMobx } from "../../../../mst/stores/mk8s.draft";
import { ProviderAutoscaler } from "../../advanced/providerAutoscaler";
import { ProviderNetworking } from "../../advanced/providerNetworking";
import { ProviderPreInstallScript } from "../../advanced/providerPreInstallScript";
import { NGInputListMst } from "../../../../newcomponents/inputList/inputListMst";
import { NGInput } from "../../../../newcomponents/input/input";
import { getDryRunErrorText } from "../../getDryRunErrorText";
import { mk8sDryRun } from "../../../../mobxStores/dryRun/mk8s";

interface Props {
  mk8s: mk8sMobx;
  mk8sDraft: Mk8sDraftMobx;
}
const ProviderHetznerAdvancedRaw: React.FC<Props> = ({ mk8s, mk8sDraft }) => {
  const h = mk8sDraft.provider_hetzner!;

  const hetznerLabelsDryRun = getDryRunErrorText({
    dryRunResponse: mk8sDryRun.response,
    path: `spec.provider.hetzner.hetznerLabels`,
    paths: h.hetznerLabels.items.map((i) => `spec.provider.hetzner.hetznerLabels.${i.firstValue}`),
  });
  const floatingIpSelectorDryRun = getDryRunErrorText({
    dryRunResponse: mk8sDryRun.response,
    path: `spec.provider.hetzner.floatingIPSelector`,
    paths: h.floatingIPSelector.items.map((i) => `spec.provider.hetzner.floatingIPSelector.${i.firstValue}`),
  });

  return (
    //
    <div>
      <NGInputListMst
        data={h.hetznerLabels}
        className="mb-8"
        label="Hetzner Labels"
        firstLabel="Key"
        firstInput={(i) => {
          let invalid = false;
          if (!i.firstValue) {
            invalid = true;
          }
          if (i.firstValue && hetznerLabelsDryRun.message.includes(`.${i.firstValue}`)) {
            invalid = true;
          }

          return (
            <NGInput
              required
              invalid={invalid}
              value={i.firstValue}
              onChange={(e) => i.setFirstValue(e.target.value)}
            />
          );
        }}
        secondLabel="Value"
        secondInput={(i) => {
          let invalid = false;
          if (!i.secondValue) {
            invalid = true;
          }

          return (
            <NGInput
              required
              invalid={invalid}
              value={i.secondValue}
              onChange={(e) => i.setSecondValue(e.target.value)}
            />
          );
        }}
        invalid={hetznerLabelsDryRun.severity === "error"}
        error={hetznerLabelsDryRun.severity === "error" ? hetznerLabelsDryRun.message : ""}
        warning={hetznerLabelsDryRun.severity === "error" ? "" : hetznerLabelsDryRun.message}
      />
      <NGInputListMst
        data={h.floatingIPSelector}
        className="mb-8"
        label="Floating IP Selector"
        firstLabel="Key"
        firstInput={(i) => {
          let invalid = false;
          if (!i.firstValue) {
            invalid = true;
          }
          if (i.firstValue && floatingIpSelectorDryRun.message.includes(`.${i.firstValue}`)) {
            invalid = true;
          }

          return (
            <NGInput
              required
              invalid={invalid}
              value={i.firstValue}
              onChange={(e) => i.setFirstValue(e.target.value)}
            />
          );
        }}
        secondLabel="Value"
        secondInput={(i) => {
          let invalid = false;
          if (!i.secondValue) {
            invalid = true;
          }

          return (
            <NGInput
              required
              invalid={invalid}
              value={i.secondValue}
              onChange={(e) => i.setSecondValue(e.target.value)}
            />
          );
        }}
        invalid={floatingIpSelectorDryRun.severity === "error"}
        error={floatingIpSelectorDryRun.severity === "error" ? floatingIpSelectorDryRun.message : ""}
        warning={floatingIpSelectorDryRun.severity === "error" ? "" : floatingIpSelectorDryRun.message}
      />
      <div className="mb-4">
        <ProviderPreInstallScript provider="hetzner" preInstallScript={h.preInstallScript} />
      </div>
      <div className="mb-4">
        <ProviderNetworking clusterDraft={mk8sDraft} networking={h.networking} readOnly />
      </div>
      <div>
        <ProviderAutoscaler provider="hetzner" autoscaler={h.autoscaler} />
      </div>
    </div>
  );
};

export const ProviderHetznerAdvanced = observer(ProviderHetznerAdvancedRaw);
